var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoaTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_eaab95059db7bfdcba5273477e117b982392b6c2663be789b3cba227ddb470ed",
    x1: 30.92,
    y1: 45.39,
    x2: 117.58,
    y2: 45.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M156.74 38.62l16.78 12.94M149.73 34a6.06 6.06 0 00-4.11-1.49l-13.31 7.09c-2.73 1.68-3.37 2.24-4.91 5.11l-6.52 12.5c0 2.16.62 3.89 2.29 4.43M148.88 57.64v-3.23l-4.54-3.45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M130.35 64.84l-6.17 5.98-7.79 3.24 2.96-8.03 37.29-37.65 5.24 4.38-24.53 24.91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M148.85 57.7l-13.85.07a4.94 4.94 0 00-4.93 5 5 5 0 005 4.93l19.91-.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M154.84 67.57s3.24.41 6.43-3.4l3.47 2.12M163.836 68.83l12.19-18.757 7.413 4.817-12.19 18.757z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_eaab95059db7bfdcba5273477e117b982392b6c2663be789b3cba227ddb470ed)",
    d: "M116.33 73.73V17.05H32.17v28.34"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M43.89 31.22h60.1M61.73 31.95v82.82M85.18 31.95v82.82M43.89 45.15h60.1M43.89 59.07h60.1M43.89 73h60.1M43.89 86.92h60.1M43.89 100.85h60.1M43.89 114.77h60.1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M32.16 55v11.32M32.16 100.28v11.32M59.32 128.58H48M80.16 128.58H68.84M100.85 128.58H89.53M32.16 122.43v6.1h5.94M110.25 128.45h6.11v-5.94M32.16 77.48V88.8M116.44 100.28v11.32M116.44 81.63v7.17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoaTemplates);
export default __webpack_public_path__ + "static/media/coaTemplates.8a8c1020a509f82fd301b36d070330a5.svg";
export { ForwardRef as ReactComponent };